import {
  CustomPeriodFilter,
  PeriodFilter,
  TWidgetSettings
} from 'types/GlobalWidget'
import { DashboardFilter } from 'types/GlobalDashboardFilter'
import { TMetricQueryParams } from 'types/GlobalMetric'

import { parseFilterQueryParams } from 'components_new/pages/Dashboard/utils'
import { filterValuesToStrings } from 'utils/metricView'

/**
 * Resolve a dashboard/report widget's baseline filters + period for the
 * underlying-data dialog, EXCLUDING any segment override (the dialog applies
 * segment + local filters on top). Mirrors the resolution the old
 * ResourceUnderlyingContentDialog did inline.
 */
export function resolveWidgetContextParams(params: {
  widgetSettings: TWidgetSettings
  dashboardFilter: DashboardFilter
  periodFilter: PeriodFilter | CustomPeriodFilter | null
}): {
  baseFilters: TMetricQueryParams['filter']
  basePeriod: CustomPeriodFilter | PeriodFilter | null
} {
  const { widgetSettings, dashboardFilter, periodFilter } = params

  const baseFilters: NonNullable<TMetricQueryParams['filter']> = {}

  const dashboardQueryParams = parseFilterQueryParams(dashboardFilter)

  dashboardQueryParams?.filter?.forEach((item) => {
    const vals = filterValuesToStrings(item.value)

    if (vals.length > 0) {
      const existing = baseFilters[item.attributeId]?.eq ?? []

      baseFilters[item.attributeId] = {
        eq: [...existing, ...vals.filter((val) => !existing.includes(val))]
      }
    }
  })

  let basePeriod: CustomPeriodFilter | PeriodFilter | null = null

  if (!widgetSettings.date_filter_is_locked && periodFilter) {
    basePeriod = periodFilter
  } else {
    const selected = widgetSettings.date_filter.selected

    if (selected?.from_date && selected?.to_date) {
      basePeriod = { from: selected.from_date, to: selected.to_date }
    }
  }

  return {
    baseFilters: Object.keys(baseFilters).length > 0 ? baseFilters : undefined,
    basePeriod
  }
}
